export default {
  HEADER_PRIMARY_BUTTON: 'ws-header [slot="primary-button"]',
  HEADER_SECONDARY_BUTTON: 'ws-header [slot="secondary-button"]',
  HEADER_LANGUAGE_SELECTOR: 'ws-header ws-language-selector',
};
